import { Component, Vue } from "vue-property-decorator";
import { CONSOLE_SOUNDS } from "@/resources/constants/sounds";
import { i18n } from "@/resources/locales";
@Component({})
export default class NetworkConnection extends Vue {
  mounted() {
    let internetNotification = null;
    window.addEventListener("offline", () => {
      internetNotification = this.$vs.notification({
        sticky: true,
        buttonClose: false,
        duration: "none",
        position: "top-center",
        color: "dark",
        text: `<div style="text-align: center">${i18n.t(
          "notifications.noInternetConnection"
        )}</div>`,
      });
    });
    window.addEventListener("online", () => {
      if (internetNotification) internetNotification.close();
    });
    /*console.log(
      JSON.stringify(
        {
          isAndroid: /Android/.test(navigator.userAgent),
          isCordova: !!window.cordova,
          isEdge: /Edge/.test(navigator.userAgent),
          isFirefox: /Firefox/.test(navigator.userAgent),
          isChrome: /Google Inc/.test(navigator.vendor),
          isChromeIOS: /CriOS/.test(navigator.userAgent),
          isChromiumBased: !!window.chrome && !/Edge/.test(navigator.userAgent),
          isIE: /Trident/.test(navigator.userAgent),
          isIOS: /(iPhone|iPad|iPod)/.test(navigator.platform),
          isOpera: /OPR/.test(navigator.userAgent),
          isSafari:
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent),
          isTouchScreen:
            "ontouchstart" in window ||
            (window.DocumentTouch && document instanceof DocumentTouch),
          isWebComponentsSupported:
            "registerElement" in document &&
            "import" in document.createElement("link") &&
            "content" in document.createElement("template"),
        },
        null,
        "  "
      )
    );*/
    const deviceType = localStorage.getItem("deviceType");
    const isChrome =
      /CriOS/.test(navigator.userAgent) ||
      (!!window["chrome"] && !/Edge/.test(navigator.userAgent));
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const isFirefox = /^((?!chrome|android).)*firefox/i.test(navigator.userAgent);
    if ((!isChrome && !isSafari && !isFirefox) && (!deviceType || deviceType !== "TABLET")) {
      this.$vs.notification({
        sticky: true,
        buttonClose: true,
        duration: "none",
        position: "top-center",
        color: "dark",
        text: `<div style="text-align: center">${i18n.t(
          "notifications.noChrome"
        )}. <a style="color:aquamarine;" href="https://www.google.com/intl/es/chrome/?brand=UUXU&gclid=CjwKCAjwgviIBhBkEiwA10D2j-ryyWSLhRTpGxfG5Q4Awiq5yzZPUi4AID6Ht82d5XkgtpmJvapVQhoCmSoQAvD_BwE&gclsrc=aw.ds"
              target="_blank">${i18n.t("notifications.downloadHere")}
       </a></div>`,
      });
    }
  }
}
